<template>
  <div class="myProjection_wrap english_container">
    <myHeader />
    <div class="banner">
      <!-- 为视频添加类名以便于样式控制 -->
      <video class="banner-video" autoplay loop muted
        src="https://download.hecoos.com/enlightv/2025-10/2382ccb62f544571a4194ba4c553d5f6.mp4"></video>
      <p style="font-size: 80px; font-weight: 900" class="wow fadeInUp enProductTitle">
        Projection Mapping
      </p>
      <p style="margin: 10px auto 0; width: 945px; height: 144px" class="wow fadeInUp enTwoProductDesc">
        Thoroughly rehearse every aspect of projection mapping to ensure the
        visuals seamlessly align with different display surfaces, maximizing
        creative potential
      </p>

      <router-link id="projection_contact_us" class="callMe"
          :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }">Contact Us</router-link>
    </div>
    <!-- 先刷重点模块 -->
    <div class="key_points">
      <p  class="wow fadeInUp enProductTitle">
        Highlight the Key Elements
      </p>
      <p style="
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 60px;
          color: rgba(255, 255, 255, 0.64);
        " class="wow fadeInUp">
        The Strengths of Projection Mapping
      </p>
      <img style="width: 1090px; height: 569px" v-if="isFirstImage"
        src="https://download.hecoos.com/enlightv/2025-17/0494d0c30f40df75b2584fef183180f2.png" alt=""
        class="wow fadeInUp" />
      <img style="width: 1090px; height: 569px" v-else
        src="https://download.hecoos.com/enlightv/2025-17/86f0c65918ebcd5e57df4637cd0cb7ac.png" alt=""
        class="wow fadeInUp" />
      <div class="button_container wow fadeInUp" ref="button_list">
        <button :class="{ btn: true, active: isBtn1Active }" @click="switchContent(1)">
          Projection Simulation
        </button>
        <button :class="{ btn: true, active: isBtn2Active }" @click="switchContent(2)">
          3D Mapping
        </button>
        <div class="underline" :style="{ width: buttonUnderlineWidth + 'px', left: buttonUnderlineLeft + 'px' }"></div>

      </div>
      <div class="text enProductCont">
        <p v-show="isFirstImage" class="wow fadeInUp">
          By simulating the optical path effects of a real projector, we can preview how people or objects in the optical path interact. This provides preemptive verification for feasibility, mitigating on-site risks.
        </p>
        <p v-show="!isFirstImage" class="wow fadeInUp">
          Simulate the optical path and image distortion of real projectors,
          precisely measuring the illumination and occlusion in the actual
          environment. With built-in parameters for multiple projector brands,
          complex light path designs and 3D mapping are easily achieved.
          Additionally, through 4-6 point calibration, the software can
          calculate the position, orientation, and output image of the projector
          in real time. Multi-user collaborative debugging significantly
          improves the efficiency of adjustments
        </p>
      </div>
    </div>
    <!-- 应用场景模块 -->
    <div class="application_scene">
      <p class="wow fadeInUp enProductTitle">
        Application Scenarios
      </p>
      <p style="
          font-size: 24px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.64);
        " class="wow fadeInUp">
        Practical Applications of Projection Mapping
      </p>
      <myBanner :applicationInfo="applicationInfo" :initialNum="0" class="wow fadeInUp"></myBanner>
    </div>
    <!-- 产品模块 -->
    <div class="product colorBlack">
      <div class="tab">
        <p class="wow fadeInUp enProductTitle" style="margin-bottom: 0px;">
          Product
        </p>
        <p class="wow fadeInUp enProductTitle">
          Your Projection Mapping Toolkit
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            Studio
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-D
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Auto-Blending
          </span>
          <span :class="{ select: currentTabIndex === 3 }" @click="selectTab(3)">
            Mirror
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="projection_content">
          <div class="studio" v-show="showContents[0]">
            <div class="layout">
              <img style="width: 647px; height: 395px"
                src="https://download.hecoos.com/enlightv/2025-17/fdb25e23aa3f7ee931dde2f6d7adc9f3.png" alt="" />
              <div class="textContent">
                <p class="enProductTitle" style="margin-bottom: 55px;">hecoos Studio</p>
                <p class="enProductCont" style="margin-bottom: 50px;">
                  Bring your vision to life. hecoos is a new media production
                  software that allows you to preview real-world scenarios in
                  advance.
                </p>
                <!-- <div class="projection_call"> -->
                <router-link to="/en/studio" class="projection_call">
                  Learn more
                </router-link>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <div class="layout">
              <img src="https://download.hecoos.com/enlightv/2025-17/b680c00af2344a487ffd382fc060f64f.png" alt="" />
              <div class="textContent">
                <p class="enProductTitle"  style="margin-bottom: 55px;">Server-D</p>
                <p class="enProductCont" style="margin-bottom: 20px;">
                  Leveraging the hecoos workflow, we optimize control over every
                  phase, from the initial inspiration for the exhibition to its
                  final on-site execution, embodying the product design
                  philosophy that "design is realization".
                </p>
                <router-link :to="{ path: '/en/mediaServer?section=0', hash: '#tab' }" class="projection_call">Learn
                  more</router-link>
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <div class="layout">
              <img src="https://download.hecoos.com/enlightv/2025-17/55f4da04f92abed02a6bb96dea4027f1.png" alt="" />
              <div class="textContent">
                <p class="enProductTitle"  style="margin-bottom: 55px;">
                  Automatic integration
                </p>
                <p class="enProductCont" style="margin-bottom: 50px;">
                  Leveraging advanced intelligent algorithms and precision
                  cameras, multiple projectors are meticulously calibrated and
                  seamlessly merged onto intricate surfaces, achieving a
                  flawless, unified visual experience. This technology reduces
                  the need for manual tuning, making it ideal for complex
                  environments while ensuring exceptional performance and visual
                  harmony.
                </p>
                <!-- <div class="projection_call">Learn more</div> -->
              </div>
            </div>
          </div>
          <div class="studio" v-show="showContents[3]">
            <div class="layout">
              <img src="https://download.hecoos.com/enlightv/2025-17/c6f4cbcf251d099852dacce7fb538d8c.png" alt="" />
              <div class="textContent">
                <p class="enProductTitle"  style="margin-bottom: 55px;">
                  hecoos Mirror
                </p>
                <p class="enProductCont" style="margin-bottom: 50px;">
                  The hecoos Mirror Track is an optical device primarily composed of a flexible rotating mirror, a drive
                  mechanism, the hecoos output control module, and other optical components, all working together
                  seamlessly.
                </p>
                <router-link to="/en/projectorbit" class="projection_call">
                  Learn more
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 创意模块 -->
    <Creativity />
    <myFooter />
    <BackToTop></BackToTop>
    <div class="test111"></div>
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import Creativity from "@/components/en_pc/creativity";
import myBanner from "@/components/en_pc/myBanner";
import BackToTop from "@/components/en_pc/BackToTop";

export default {
  data() {
    return {
      initialNum: '',
      underlineWidth: 0,
      underlineLeft: 0,
      currentButtonIndex: 1,
      buttonUnderlineWidth: 0,
      buttonUnderlineLeft: 0,
      isFirstImage: true,
      // 用于控制按钮的激活状态
      isBtn1Active: true,
      isBtn2Active: false,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          title: "Stage Performance",
          msg: 'When facing the rehearsal interface of hecoos together, artists and engineers can collaborate to discuss and clearly define every detail of the scheme. This process lays a solid and reliable foundation. As a result, it ensures the smooth progress and splendid presentation of the performance.',
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/a3e5c338323377cdd937e4d8984cd419.png'
        },
        {
          title: "Art Exhibition",
          msg: `Every movement of the audience may trigger the creative playback of the video content, the wonderful operation of the mechanical devices, and the dynamic changes of the lighting atmosphere. This makes the exhibition no longer a one-way display but an interactive journey full of vitality and surprises, thereby greatly enhancing the audience's sense of participation and immersion.`,
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/a3131e62c05538ab68c4cab37923de27.png'
        },
      ],
    };
  },
  methods: {
    // 切换内容和按钮激活状态的方法
    switchContent(type) {
      this.currentButtonIndex = type;
      this.buttonUpdateUnderlinePosition()
      if (type === 1) {
        this.isFirstImage = true;
        this.isBtn1Active = true;
        this.isBtn2Active = false;
      } else {
        this.isFirstImage = false;
        this.isBtn1Active = false;
        this.isBtn2Active = true;
      }
    },

    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

    // 导航切换底部跟随
    buttonUpdateUnderlinePosition() {
      const switchList = this.$refs.button_list;
      if (switchList) {
        const button = switchList.querySelectorAll('button')[this.currentButtonIndex - 1];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = button.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(button);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.buttonUnderlineWidth = spanRect.width + paddingLeft - paddingRight;

        // 计算去除 padding 后的左侧偏移量
        this.buttonUnderlineLeft = spanRect.left - switchListRect.left - paddingLeft + paddingRight;
      }

    },
    // 文字宽度变化监听
    buttonSetupSpanResizeObservers() {
      const buttons = this.$refs.button_list.querySelectorAll('button');
      const resizeCallback = () => {
        this.buttonUpdateUnderlinePosition();
      };
      buttons.forEach(button => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(button);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      this.buttonUpdateUnderlinePosition();
      this.buttonSetupSpanResizeObservers()
      window.addEventListener('resize', this.updateUnderlinePosition);
      window.addEventListener('resize', this.buttonUpdateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("resize", this.buttonUpdateUnderlinePosition);
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    myBanner,
    BackToTop,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";
@import "@/styles/optimize_adaptation.scss";
.callMe {
      display: inline-block;
      text-decoration: none;
      padding: 16px 24px;
      line-height: 32px;
      border-radius: 40px;
      background-color: #147cf5;
      margin: 0 auto;
      margin-top: 100px;
      font-size: 22px;
      cursor: pointer;
      color: #fff;
      transition: all 0.3s ease;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #147cf5;
    }
</style>
